import React from "react";
import { Link } from "react-router-dom";

function Cover(props) {
  return (
    <Link
      to={props.url}
      className="rounded-md hover:cursor-pointer group hover:grayscale-[50%] relative xmd:w-[40%] w-full drop-shadow-lg bg-slate-50"
    >
      {props.thumbnail ? (
        <video
          autoPlay
          loop
          muted
          src={props.thumbnail}
          className="rounded-md"
        />
      ) : (
        <img src={props.fallback} />
      )}

      <div className="bg-white bg-opacity-50 group-hover:bg-opacity-60 group-hover:backdrop-blur-md transition rounded-b-md absolute w-full bottom-0 py-2 pl-5">
        <h1 className="font-bold text-zinc-700">{props.title}</h1>
        <p className="font-light text-sinc-500 text-sm">{props.description}</p>
      </div>
    </Link>
  );
}

export default Cover;
